export const DEFAULT_DASHBOARD_RETURN_STATE_TTL_HOURS = 6;

export function dashboardStateStorageKey({ accountId, schoolId, contextKey } = {}) {
  if (!accountId || !schoolId || !contextKey) return null;
  return `ee:dashboardReturn:v2:${[accountId, schoolId, contextKey].map(encodeURIComponent).join(":")}`;
}

export function getDashboardStateTtlMs(ttlHours = DEFAULT_DASHBOARD_RETURN_STATE_TTL_HOURS) {
  const parsedTtl = Number(ttlHours);
  const safeTtlHours = Number.isInteger(parsedTtl) && parsedTtl > 0
    ? parsedTtl
    : DEFAULT_DASHBOARD_RETURN_STATE_TTL_HOURS;

  return safeTtlHours * 60 * 60 * 1000;
}

export function readDashboardState(scope, ttlHours = DEFAULT_DASHBOARD_RETURN_STATE_TTL_HOURS, now = Date.now()) {
  const key = dashboardStateStorageKey(scope);
  if (!key || typeof localStorage === "undefined") return null;

  try {
    const rawState = localStorage.getItem(key);
    if (!rawState) return null;

    const state = JSON.parse(rawState);
    const savedAt = Number(state.savedAt);
    const date = new Date(state.date);

    if (!savedAt || now - savedAt > getDashboardStateTtlMs(ttlHours)) return null;
    if (Number.isNaN(date.getTime())) return null;

    return {
      teacherId: state.teacherId,
      date,
    };
  } catch (error) {
    return null;
  }
}

export function writeDashboardState(scope, {
  teacherId,
  date,
}, now = Date.now()) {
  const key = dashboardStateStorageKey(scope);
  if (!key || typeof localStorage === "undefined" || !teacherId || !(date instanceof Date) || Number.isNaN(date.getTime())) return;

  try {
    localStorage.setItem(key, JSON.stringify({ teacherId, date: date.toISOString(), savedAt: now }));
  } catch (error) {
    // Returning to the dashboard is still possible when browser storage is disabled.
  }
}
